/* eslint-disable @reatom/unit-naming-rule */
import { action } from '@reatom/framework'
import i18next from 'i18next'

import { AsyncStateN, Result } from '@blade/std-lib'
import { delugeIdAtom } from '@root/entities/auth'
import { currencyAddLogoEvent } from '@root/entities/currency/atoms'
import {
  openBuyPremiumFlowEvent,
  openPremiumCurrencyDetailsEvent,
  premiumMetaRegistry,
} from '@root/entities/premium/atoms'
import * as ReatomProfile from '@root/entities/profile'
import { referralCodeUpdateEvent } from '@root/entities/realtime'
import { checkIsPremiumBelongToUsedAction } from '@root/features/premium'
import { openTradeSettingsDialogEvent } from '@root/features/trade/trade-settings'
import { showSnackbarAction } from '@root/shared/ui-kit'
import { tradeSettingsDialogParamsAtom } from '@root/widgets/trade/trade-settings/atoms/options-dialog-atom'

import type { CurrencyModel } from '@root/entities/currency/model'

export const initializeMessaging = action(() => {}, 'initializeMessaging')

export const initializePremiumFlowsAction = action(() => {
  const handleAddLogoAction = action(async (ctx, currency: CurrencyModel) => {
    const premiumMeta = premiumMetaRegistry.get(currency.address)
    const premiumId = premiumMeta ? ctx.get(premiumMeta.premiumId) : undefined
    if (!premiumMeta || !premiumId) {
      openBuyPremiumFlowEvent(ctx, { currency, premium: undefined })
      return
    }

    // Whose logo it is decides what this does, so an account is what is
    // needed — the desktop app is not.
    const delugeId = ctx.get(delugeIdAtom)
    if (!delugeId) {
      return
    }

    const owner = ctx.get(premiumMeta.owner)
    if (owner && owner.delugeId === delugeId) {
      openPremiumCurrencyDetailsEvent(ctx, {
        currencyAddress: currency.address,
      })
    }

    const isEligibleResult = await ctx.schedule(() =>
      checkIsPremiumBelongToUsedAction(ctx, {
        premiumId,
      }),
    )

    if (Result.isFailure(isEligibleResult)) {
      return
    }

    if (!isEligibleResult.success.isEligible) {
      showSnackbarAction(ctx, {
        intent: 'info',
        text: i18next.t('premium.not-eligible-snackbar.title'),
        description: i18next.t('premium.not-eligible-snackbar.description'),
      })
      return
    }

    openPremiumCurrencyDetailsEvent(ctx, {
      currencyAddress: currency.address,
    })
    return
  })
  currencyAddLogoEvent.onCall(handleAddLogoAction)
})

export const initializeReferralCodeProfileUpdate = () =>
  referralCodeUpdateEvent.onCall((ctx, update) => {
    const networkProfileAtom = ReatomProfile.byNetwork[update.network]
    const profileState = ctx.get(networkProfileAtom)

    AsyncStateN.map(profileState, (profile) => {
      if (profile.delugeId !== update.delugeId) {
        return
      }

      const updatedProfile = ReatomProfile.Profile.updateReferralCode({
        profile,
        network: update.network,
        referralCode: update.referralCode,
      })

      networkProfileAtom.setSuccess(ctx, updatedProfile)
    })
  })

export const initializeOptionsDialogOpen = () => {
  openTradeSettingsDialogEvent.onCall((ctx, params) => {
    tradeSettingsDialogParamsAtom(ctx, params)
  })
}
